import {Coach} from "../../src/interfaces/interfaces";
import {TrenerskaTrida} from "../../src/interfaces/enums";

const judges : Coach[] = [
    {
        level: TrenerskaTrida.brevet,
        name: 'Kapounková Kateřina',
    },
    {
        level: TrenerskaTrida.brevet,
        name: 'Langová Hanne',
    },
    {
        level: TrenerskaTrida.trida1,
        name: 'Pavlíková Michaela',
    },
    {
        level: TrenerskaTrida.trida1,
        name: 'Surková Iva',
    },
    {
        level: TrenerskaTrida.trida2,
        name: 'Štaudrová Petra',
    },
    {
        level: TrenerskaTrida.trida2,
        name: 'Urbancová Markéta',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Bohuslavová Simona',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Dohnalová Kristýna',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Frydrychová Lenka',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Hudáková Eva',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Kapounková Karolína',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Langová Jiřina',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Nováková Radana',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Rybková Veronika',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Suchomelová Dana',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Šnajdárová Eva',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Vágnerová Lenka',
    },
    {
        level: TrenerskaTrida.trida3,
        name: 'Vejrostová Květa',
    },
    {
        level: TrenerskaTrida.trida4,
        name: 'Bubníková Hanna',
    },
    {
        level: TrenerskaTrida.trida4,
        name: 'Dohnalová Šárka',
    },
    {
        level: TrenerskaTrida.trida4,
        name: 'Sládková Nicol',
    },
    {
        level: TrenerskaTrida.trida4,
        name: 'Suchomelová Kvetoslava',
    },
    {
        level: TrenerskaTrida.trida4,
        name: 'Trgalová Helena',
    },
]

export default judges